import { h } from "preact"
import { useEffect, useState } from "preact/hooks";
import { CSSProperties } from "styled-components";
import { useQuery } from "../../hooks/useQuery";
import { StyledButtonPrimary } from "./styled"

interface IPrimaryButton {
    label: string;
    style?: CSSProperties;
    mobileStyle?: CSSProperties;
    tabletStyle?: CSSProperties;
    isDisabled?: boolean;
    isLoading?: boolean;
    forceLoading?: boolean;
    onPress?(): Promise<void> | boolean | void;
}

export const PrimaryButtonClosed = ({
    label,
    style,
    mobileStyle,
    tabletStyle,
    isDisabled,
    isLoading,
    forceLoading,
    onPress
}: IPrimaryButton) => {
    const { isMobile, isTablet } = useQuery();
    const [loading, setLoading] = useState(forceLoading);

    useEffect(() => {
        setLoading(forceLoading)
    }, [forceLoading])

    const onPressButton = async () => {
        isLoading && setLoading(true);
        onPress && await onPress();
        isLoading && setLoading(false);
    }

    const s = isMobile ? mobileStyle : isTablet ? tabletStyle : style ;
    return <StyledButtonPrimary style={s} loading={loading} disabled={isDisabled} onClick={onPressButton}>
        {label}
    </StyledButtonPrimary>
}